/**
 * Application feature flags.
 *
 * Flags are read from the environment at build time with a hardcoded safe
 * fallback (off) so that a missing or malformed env value never enables a gated
 * capability.
 */

/**
 * Gates the Materials create/edit (CRUD) capability in the Group Dashboard.
 *
 * Stays OFF until backend dependency G6 (Materials create/edit product decision)
 * is confirmed. Enable by setting `REACT_APP_G6_MATERIALS_CRUD=true`.
 */
export const G6_MATERIALS_CRUD: boolean =
  process.env.REACT_APP_G6_MATERIALS_CRUD === 'true';

/**
 * Gates the bulk "remind debtors" action in the Group Dashboard Students tab.
 *
 * Stays OFF until the backend exposes a real reminder/notification mutation.
 * The current per-item action (`checkStudentDebt`) only VALIDATES debt — it
 * does not notify anyone — so claiming «Напоминания отправлены» would be
 * misleading. The button, hook (`useRemindDebtors`), and copy are kept ready
 * behind this flag; enable by setting `REACT_APP_DEBTOR_REMINDERS=true` once
 * the real mutation lands (see docs/groups/backend_tz_group_card_followup.md §B1).
 */
export const DEBTOR_REMINDERS: boolean =
  process.env.REACT_APP_DEBTOR_REMINDERS === 'true';
